<template>
  <div
    :style="{
      backgroundColor: extras.download ? extras.download.bg : defaultColor,
    }"
    class="m-load top-nav m-journalism"
    v-if="extras.download.display == 1"
    id="download"
  >
    <WapTitle
      v-if="extras.downloadTitle.display == 1"
      :title="extras.downloadTitle.model || title"
      :icon="icon"
      :titleFont="extras.downloadTitle.color"
    />
    <ul class="tab tab-left" v-if="folderList.length > 1">
      <li
        v-for="(item, index) in folderList"
        :key="index"
        :class="{ active: item.id == currentId }"
        @click="columnClick(item)"
      >
        {{ item.name }}
      </li>
    </ul>
    <ul class="data-body" v-if="fileList && fileList.length > 0">
      <li
        v-for="(soud, index) in fileList"
        :key="index"
        :style="{
          display: isShowMore == false && index > 3 ? 'none' : '',
        }"
      >
        <span v-for="(sliad, index) in imgList" :key="index"
          ><img
            :src="sliad.img"
            alt=""
            class="format"
            v-if="soud.type == sliad.type"
        /></span>

        <span @click="see(soud)">{{ soud.name }}</span>
        <span
          alt=""
          class="icon icontemp download download"
          @click="download(soud)"
        >
        </span>
      </li>
    </ul>
    <img
      class="more"
      v-if="fileList && fileList.length > 4"
      :src="
        isShowMore == false
          ? require('@/assets/images/wap/showmore.png')
          : require('@/assets/images/wap/hidemore.png')
      "
      @click="showMoreArticle"
    />
    <div class="no-data" v-if="fileList && fileList.length == 0">
      <img :src="require('@/assets/images/nodata.png')" />
      <div class="no-data-text">暂无数据</div>
    </div>

    <vodal :show="show" animation="zoom" @hide="show = false">
      <div class="mail-box" v-if="Sent">
        <div class="title">请输入您的邮箱</div>
        <div class="mail">
          <input type="text" placeholder="请输入您的邮箱" v-model="mailbox" />
          <span>{{ tip }}</span>
        </div>
        <div class="btn" @click="determine()">确定</div>
      </div>
      <div class="success" v-else>
        <p>已下载成功</p>
        <div>请稍后查看您的邮箱</div>
      </div>
    </vodal>
  </div>
</template>

<script>
import WapTitle from "@/components/index/WapTitle.vue";
import { interact, URLS } from "fire-wind-water/index";
import Api from "@/service/api";

export default {
  components: {
    WapTitle,
  },
  props: {
    fileInfo: Object,
    extras: Object,
    seminarInfo: Object(),
  },
  data() {
    return {
      listArr: [],
      show: false,
      Sent: true,
      imgList: [
        {
          img: require("@/assets/images/wap/icon/pdf.png"),
          type: "pdf",
        },
        {
          img: require("@/assets/images/wap/icon/audio.png"),
          type: "audio",
        },
        {
          img: require("@/assets/images/wap/icon/docx.png"),
          type: "docx",
        },
        {
          img: require("@/assets/images/wap/icon/flv.png"),
          type: "flv",
        },
        {
          img: require("@/assets/images/wap/icon/img.png"),
          type: "img",
        },
        {
          img: require("@/assets/images/wap/icon/ppt.png"),
          type: "ppt",
        },
        {
          img: require("@/assets/images/wap/icon/txt.png"),
          type: "txt",
        },
        {
          img: require("@/assets/images/wap/icon/video.png"),
          type: "video",
        },
        {
          img: require("@/assets/images/wap/icon/xlsx.png"),
          type: "xlsx",
        },
        {
          img: require("@/assets/images/wap/icon/zip.png"),
          type: "zip",
        },
      ],
      tip: "",
      mailbox: "", // 邮箱
      title: "资料下载",
      icon: require("@/assets/images/wap/xiazai.png"),
      fileList: [],
      folderList: [],
      currentId: 0,
      isShowMore: false,
      defaultColor: "#ffffff",
    };
  },
  mounted() {
    //this.initColumns();
    let tempColumns = this.getColumns.fileInitColumns(
      this.fileInfo.folderList,
      this.fileInfo.fileList,
      "大会资料"
    );
    this.folderList = tempColumns;
    this.fileList =
      this.folderList.length == 0 ? [] : this.folderList[0].fileList;
    this.currentId = this.folderList.length == 0 ? 0 : this.folderList[0].id;
  },
  methods: {
    initColumns() {
      let tempArticles = this.fileInfo.fileList;
      let tempColumns = this.fileInfo.folderList;
      const columns = [
        {
          id: 0,
          name: "大会资料",
          fileList: tempArticles,
        },
      ];
      for (let i in tempColumns) {
        columns.push(tempColumns[i]);
      }
      this.folderList = columns;
      this.fileList = this.folderList[0].fileList;
      this.currentId = this.folderList[0].id;
    },
    columnClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = item.id;
      console.log("item", item);
      this.fileList = item.fileList;
    },
    DayClick(i) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = i;
    },
    determine() {
      var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.mailbox)) {
        this.tip = "请输入正确邮箱";
      } else {
        var vm = this;
        vm.downloadEvent(this.mailbox, this.listArr);
      }
    },
    handlePreview(previewUrl) {
      const url = window.location.href;
      let previewCode = "11291";
      switch (url) {
        case url.indexOf("://dev") >= 0:
          previewCode = "11291";
          break;
        case url.indexOf("://tf") >= 0:
          previewCode = "18077";
          break;
        case url.indexOf("://uf") >= 0:
        case url.indexOf("://uat") >= 0:
          previewCode = "14461";
          break;
        default:
          previewCode = "14460";
          break;
      }
      const protocolMatch = previewUrl.indexOf("https");
      let resultUrl = `http://ow365.cn/?i=${previewCode}&furl=${previewUrl}&type=download`;
      if (protocolMatch === 0) {
        resultUrl = `http://ow365.cn/?i=${previewCode}&ssl=1&furl=${previewUrl}&type=download`;
      }
      return resultUrl;
    },
    see(file) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      const previewUrl = this.handlePreview(file.preview);
      window.$sk.goto(previewUrl, true).subscribe((url) => {
        window.open(url);
      });
      //      const { tenantId, weChatId } = this.seminarInfo;
      const userInfo = this.userInfo;
      Api.previewFile({
        browseInfo: interact.browseInfo,
        currentUrl: file.preview,
        fileId: file.id,
        globalUserId: userInfo.globalUserId,
        sess: userInfo.session,
        tenantId: URLS.getURL("tenantId"),
        weChatId: URLS.getURL("weChatId"),
        source: "WAP",
      });
    },
    download(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      var arr = [];
      if (item.identity == 3 && item.registerFormId) {
        //需要登录
        const info = window.$sk.template.get();
        const smarketMember = info.cookie.getSession();
        this.isLogin = !!smarketMember;
        if (this.isLogin) {
          this.path = item.previewRealPath;
          arr = [];
          arr.push(item.id);
          // this.fileList = arr;
          this.listArr = [item.id];
          this.show = true;
          this.Sent = true;
          this.tip = "";
        } else {
          this.getForm(item.registerFormId).then((res) => {
            if (res.result == 0) {
              const loginUrl = URLS.updateSearchParam(
                "backUrl",
                encodeURIComponent(window.location.href),
                res.content.originUrl.wap
              );
              window.$sk.goto(loginUrl);
            }
          });
        }
      } else {
        this.path = item.previewRealPath;
        arr = [];
        arr.push(item.id);
        // this.fileList = arr;
        this.listArr = [item.id];
        this.show = true;
        this.Sent = true;
        this.tip = "";
      }
    },
    downloadEvent(mailbox, fileList) {
      const instanceId = URLS.getURL("instanceId");
      const info = window.$sk.template.get();
      const { globalUserId } = info.user;
      Api.getDownloadWithEmail({
        instanceId,
        email: mailbox,
        globalUserId,
        moduleType: 3,
        fileList,
      }).subscribe((item) => {
        console.log("item", item);
        this.tip = item ? item.desc : "";
        this.Sent = false;
      });
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>
<style scoped></style>
